import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WaterBalanceService {
  constructor(private $http: SuperHttpClientProvider) {}

  getConfig<T = any>(moduleId: number): Observable<T> {
    return this.$http.default.get(
      `/admin/module/${moduleId}/water-balance-config`
    );
  }

  updateConfig(moduleId: number, payload: any): Observable<any> {
    return this.$http.default.put(
      `/admin/module/${moduleId}/water-balance-config`,
      payload
    );
  }

  getCrops<T = any>(): Observable<T> {
    return this.$http.default.get('/admin/crops');
  }

  getWeeklyKc<T = any>(
    moduleId: number,
    start: string,
    end: string
  ): Observable<T> {
    return this.$http.default.get(`/admin/module/${moduleId}/weekly-kc`, {
      params: { start, end }
    });
  }

  getWeeklyPrecipitation<T = any>(
    moduleId: number,
    start: string,
    end: string
  ): Observable<T> {
    return this.$http.default.get(
      `/admin/module/${moduleId}/weekly-precipitation`,
      {
        params: { start, end }
      }
    );
  }

  getWeeklyBalance<T = any>(
    moduleId: number,
    start: string,
    end: string,
    debug?: boolean
  ): Observable<T> {
    const params: any = { start, end };
    if (debug) {
      params.debug = 1;
    }
    return this.$http.default.get(`/admin/module/${moduleId}/weekly-balance`, {
      params
    });
  }

  getWeeklyReport<T = any>(
    moduleId: number,
    start: string,
    end: string,
    debug?: boolean
  ): Observable<T> {
    const params: any = { start, end };
    if (debug) {
      params.debug = 1;
    }
    return this.$http.default.get(`/admin/module/${moduleId}/weekly-report`, {
      params
    });
  }
}
